import { z } from "zod/v4";

export const emailLinkPostSchema = z.object({
  name: z.string().optional(),
  active: z.boolean(),
  url: z.string(),
  original_name: z.string().optional(),
  link_templates: z.record(z.string(), z.record(z.string(), z.string())).optional(),
  is_tracked: z.boolean(),
  lid: z.string().optional(),
  nested: z.boolean().optional(),
  is_draft: z.boolean().optional(),
});
